<template>
  <div
    class="tab flex-grow"
    :class="{
      'partial-width':
        !isLastOddTab && !noTabClasses && ($mq === 'sm' || totalTabs > 3),
      'full-width':
        isLastOddTab && !noTabClasses && ($mq === 'sm' || totalTabs > 3)
    }"
  >
    <i :class="iconClassName"></i>
    <span class="capitalize select-none">{{ tabText }}</span>
  </div>
</template>

<script>
export default {
  name: "BdgTab",
  props: {
    iconClassName: String,
    tabText: String,
    isSelected: Boolean,
    isLastOddTab: Boolean,
    noTabClasses: Boolean,
    totalTabs: Number
  }
};
</script>

<style lang="scss" scoped>
.uppercase {
  .tab {
    span {
      @apply uppercase;
    }
  }
}
</style>
